<template>
  <section>
    <slot>
      <router-view/>
    </slot>
  </section>
</template>
<script lang="ts" setup>
defineOptions({
  name: 'CompanyIndex',
});
</script>